import { Box, Typography } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { AddendumFormType, applyWhatNeedsUpdatingExclusivity, TextInput, WhatNeedsUpdating } from '@uplift/ui-v2';
import { Session } from '@uplift/api';
import { useAllDiagnosisQuery, useSessionDiagnosisQuery } from '@uplift/queries';
import { NoteSection } from '../../pages/notes-page/components/NoteSection';
import { NoteSectionCloseButton } from '../../pages/notes-page/components/NoteSectionCloseButton';
import { DiagnosisSelect } from '../diagnosis-select';

export type AmendAddendumDiagnosisSectionProps = {
  session: Session;
};

export const AmendAddendumDiagnosisSection: React.VFC<AmendAddendumDiagnosisSectionProps> = ({ session }) => {
  const formik = useFormikContext<AddendumFormType>();
  const [ , , whatNeedsUpdatingHelpers ] = useField<WhatNeedsUpdating[]>('whatNeedsUpdating');
  const { data: asSignedDiagnosis } = useSessionDiagnosisQuery(session);
  const { data: diagnoses = [] } = useAllDiagnosisQuery();

  const handleClose = () => {
    whatNeedsUpdatingHelpers.setValue(applyWhatNeedsUpdatingExclusivity(formik.values.whatNeedsUpdating, formik.values.whatNeedsUpdating.filter(v => v !== 'dx')));
    formik.setFieldValue('diagnosisIds', session.diagnosisIds ?? []);
    formik.setFieldValue('diagnosisCodeChangeReason', '');
  };

  const closeIcon = Boolean(formik.values.diagnosisCodeChangeReason)
    || formik.values.diagnosisIds.length !== (session.diagnosisIds ?? []).length;

  return (
    <NoteSection
      title="Amend Diagnosis"
      onDelete={<NoteSectionCloseButton onDelete={handleClose} closeIcon={closeIcon} />}
    >
      <Box px={3}>
        <Box pb={3}>
          <Typography variant="overline" color="textSecondary">As signed</Typography>
          <Typography>
            {asSignedDiagnosis?.length ? asSignedDiagnosis.map(({ code, name }) => `${code}: ${name}`).join(', ') : 'None'}
          </Typography>
        </Box>
        <Box pb={3}>
          <TextInput
            name="diagnosisCodeChangeReason"
            label="Code change reason"
            color="secondary"
            multiline
            rows={3}
            fullWidth
          />
        </Box>
        <DiagnosisSelect
          name="diagnosisIds"
          diagnoses={diagnoses}
          color="secondary"
          buttonTextVariant
        />
      </Box>
    </NoteSection>
  );
};
